import React, {useState} from 'react'
import {Portlet, PortletBody, PortletFooter, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import {Col, Dropdown, Row} from "react-bootstrap";
import LoadingButton from "../../../base/components/loadingButton";
import { connect } from "react-redux";
import {useController, useForm} from "react-hook-form";
import _ from "lodash";
import ApiSelect from "../../../base/components/forms/apiSelect";
import FormHookInput from "../../../air/airBooking/components/formHookInput";
import BlockUi from "@availity/block-ui";
import DropdownButton from "react-bootstrap/DropdownButton";
import RightEditComponent from "./rightEditComponent";
import {useParams} from "react-router-dom";


const CityForm  = ({data, onSubmit, edit, deleteAction}) =>{
  const [loading, setLoading] = useState()
  const { id } = useParams();
  const {register,
    control,
    setValue,
    watch,
    reset,
    getValues,
    formState:{errors},
    handleSubmit} = useForm(
      {defaultValues:data}
  )
  const {
    field: { onChange: countryOnChange, value: countryValue }
  } = useController({
    name: `country`,
    control,
    rules: { required: true },
    defaultValue: data.country
  });
  const onSubmitBase = (data)=>{
    if(data.lat === '' || isNaN(data.lat) || data.lat === null) delete data.lat
    if(data.lon === '' || isNaN(data.lon) || data.lon === null) delete data.lon
    setLoading(true)
    onSubmit(data)
  }

  const lat = watch("lat")
  const lng = watch("lon")
  return <Row>
    <Col lg={6}>
      <Portlet>
        <PortletHeader
          title={edit ? "Редактирование города" : "Создание города"}
          toolbar={
            <PortletHeaderToolbar>
              {edit && <BlockUi blocking={loading}>
                <DropdownButton variant="outline-danger" title="Удалить">
                  <Dropdown.Item as="button" onClick={deleteAction}>
                    Да! Удалить
                  </Dropdown.Item>
                </DropdownButton>
              </BlockUi>}
            </PortletHeaderToolbar>
          }
        />
        <BlockUi blocking={loading || !data}>
          <form onSubmit={handleSubmit(onSubmitBase)} >
            <PortletBody className={'d-flex flex-column gap-3'}>
              <FormHookInput
                register={register(`name`,)}
                label={'Название'}
                errors={errors}
              />
              <FormHookInput
                register={register(`nameEn`, {
                  required: true,
                })}
                label={'Название En'}
                errors={errors}
              />
              <FormHookInput
                register={register(`code`,)}
                label={'Код города'}
                errors={errors}
              />
              <FormHookInput
                register={register(`stateCode`,)}
                label={'Код штата'}
                errors={errors}
              />
              <FormHookInput
                register={register(`lat`, {
                  valueAsNumber: true,
                })}
                label={'Lat'}
                errors={errors}
              />
              <FormHookInput
                register={register(`lon`, {
                  valueAsNumber: true,
                })}
                label={'Lon'}
                errors={errors}
              />
              <ApiSelect
                value={countryValue}
                label={'Страна'}
                hasError={_.get(errors, `seller`)}
                url={"/api/locations/countries/searchInput"}
                cb={countryOnChange}
              />
            </PortletBody>
              <PortletFooter className={'text-end'}>
                <LoadingButton title={"Сохранить"} loading={loading}/>
              </PortletFooter>
          </form>
        </BlockUi>
      </Portlet>
    </Col>
    <RightEditComponent edit={edit}
                        link={`/api/locations/cities/syncCity/${id}`}
                        citySyncCb={(data)=>{
                          console.log('city',data.city)
                          reset({
                            ...getValues(),
                            ...data.city
                          });
                        }}
                        defaultZoom={6}
                        coordinates={!!lat && !!lng ? {lat, lng } : null}/>
  </Row>
}
export default CityForm;
